import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { reviewEntry } from "@/api/chatbot/chatbot";
export default {
  name: "reviewDocument",
  data: function data() {
    return {
      dialog: false,
      pramsData: {
        entry_id: '',
        query: '',
        queries: '',
        linked_tables: '',
        semantic_entry_limit: '',
        previous_execution_limit: ''
      },
      rules: {}
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      if (data) {
        this.pramsData.entry_id = data.entry_id;
      }

      this.dialog = true;
    },
    resetForm: function resetForm() {
      this.dialog = false;
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this.pramsData));
          data.previous_execution_limit = Number(data.previous_execution_limit);
          data.semantic_entry_limit = Number(data.semantic_entry_limit);
          data.linked_tables = data.linked_tables ? data.linked_tables.split(",") : [];
          data.queries = data.queries ? data.queries.split(",") : [];
          reviewEntry(_objectSpread({}, data)).then(function (res) {
            if (res.detail) {
              _this.$message({
                type: "error",
                message: res.detail
              });
            } else {
              _this.$emit('change', {
                review_id: res.review_id,
                entry_id: _this.pramsData.entry_id
              });

              _this.$message({
                type: "success",
                message: 'Review成功'
              });

              _this.resetForm();
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.pramsData = {
        entry_id: '',
        query: '',
        queries: '',
        linked_tables: '',
        semantic_entry_limit: '',
        previous_execution_limit: ''
      };
      this.$refs.ruleForm.resetFields();
    }
  }
};